<template>
    <contact-companies-view/>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import ContactCompaniesView from '../../../components/views/ContactCompaniesView2.vue'
import store from '../../../store'

export default {
  components: {
    ContactCompaniesView
  },
  props: {},
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    // store.dispatch('moduleView/getModuleViews')
    //   .then(() => {
    //
    //   })

    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>